export default {
	title: "Thèmes",
	darkMode: "Mode sombre",
	orixas: {
		ori: "ORI",
		exu: "Exú",
		ogum: "Ogum",
		oxossi: "Oxóssi",
		xango: "Xangô",
		oxum: "Oxum",
		iemanja: "Iemanjá",
		oxala: "Oxalá",
		nana: "Nanã",
		iansa: "Iansã",
		ibeji: "Ibeji",
	},
	descriptions: {
		ori: "Thème par défaut du système ORI",
		exu: "Gardien des chemins - Noir et Rouge",
		ogum: "Orixá des chemins et de la guerre - Rouge",
		oxossi: "Orixá de la chasse et de l'abondance - Vert et Bleu",
		xango: "Orixá de la justice et de la foudre - Brun et Blanc",
		oxum: "Orixá des rivières et de l'amour - Bleu foncé",
		iemanja: "Reine de la mer - Bleu et Blanc",
		oxala: "Père de tous les orixás - Blanc pur",
		nana: "Orixá ancestral - Violet et Lilas",
		iansa: "Maîtresse des vents et des tempêtes - Jaune et Corail",
		ibeji: "Orixás jumeaux de la joie - Bleu clair et Rose",
	},
};
